import { getAccessToken } from "../suite/auth";
import { parseMimicJson, type MusicMimic } from "./mimic";

async function mimicShelfRequest(method: string, body?: unknown, id?: string): Promise<Response> {
  const tok = getAccessToken();
  if (!tok) throw new Error("Sign in to save mimics to your Hugging Face shelf.");
  const url = id ? `/api/mimic/shelf?id=${encodeURIComponent(id)}` : "/api/mimic/shelf";
  const res = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${tok}`,
      ...(body ? { "Content-Type": "application/json" } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(err?.error || `Mimic shelf failed (${res.status})`);
  }
  return res;
}

export async function fetchRemoteMimicShelf(): Promise<MusicMimic[]> {
  const res = await mimicShelfRequest("GET");
  const data = (await res.json()) as { mimics?: unknown[] };
  return (data.mimics || []).map(parseMimicJson).filter((m): m is MusicMimic => Boolean(m));
}

export async function putRemoteMimic(m: MusicMimic): Promise<string> {
  const res = await mimicShelfRequest("PUT", m);
  const data = (await res.json()) as { path?: string };
  return data.path || "";
}

export async function deleteRemoteMimic(id: string): Promise<void> {
  await mimicShelfRequest("DELETE", undefined, id);
}
